import { Badge, Box, Container, Grid, Image, Skeleton } from '@chakra-ui/react'
import type { AppInfoMessage } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { useGetAllAppInfoMessages } from 'BrokerTsLib/src/hooks/useAppInfoMessage'
import { useEffect, useMemo } from 'react'

import chaloupkaDashboardImage from '../../assets/images/chaloupka-dashboard-image.jpg'
import { Card, CardBody, CardTitle } from '../../components/Card'
import { ProductionGraph } from '../../components/ProductionGraph'
import { Section } from '../../components/Section'
import { NewsList } from '../../containers/news/NewsList'
import { useAuth } from '../../context/AuthContext'
import { useApp } from '../../hooks/useApp'
import { fadeInLeft } from '../../utils/fadeInLeft'
import AnniversaryWidget from './widget/anniversary'
import ConceptsWidget from './widget/concepts'

const showMessageLimit = 3

export const DashboardPage = () => {
  const { product, setProduct } = useApp()

  const { mutateAsync: getMessages, data: dataMessages, isLoading } = useGetAllAppInfoMessages()
  const filter = useMemo(() => ({
    product: product!,
    pageIndex: 1,
    pageSize: showMessageLimit,
    shown: true
  }), [product])

  let news = (dataMessages?.data?.items ?? []) as AppInfoMessage[]

  useEffect(() => {
    getMessages(filter)
  }, [filter, getMessages])

  news = news.sort((a, b) => new Date(b.dateCreatedMember).getTime() - new Date(a.dateCreatedMember).getTime())

  const messagesCount = dataMessages?.data?.totalCount ?? 0

  const { chaloupkaUnreadMessages: unreadCount } = useAuth()!

  // Resetovat product na PropertyInsurance
  useEffect(() => {
    setProduct(Product.PropertyInsurance)
  }, [])

  return (
    <Section>
      <Container>
        <Grid sx={{ gap: 8 }}>
          <Grid
            className="dashboard-header"
            sx={{
              gridTemplateColumns: { base: '1fr', xl: '1fr 2fr' },
              gap: 4,
              justifyContent: 'space-around',
            }}
          >
            <Card sx={{ order: { base: 1, xl: 0 } }}>
              <CardTitle>
                Aktuality
                {unreadCount > 0 && <Badge>{unreadCount}</Badge>}
              </CardTitle>

              <CardBody sx={{ p: 0 }}>
                <Skeleton isLoaded={!isLoading} sx={{ ...isLoading ? { m: 4, h: 80 } : {} }}>
                  {news && <NewsList news={news} showMoreLink={messagesCount > showMessageLimit} />}
                </Skeleton>
              </CardBody>
            </Card>

            <Box sx={{ display: 'grid', placeContent: 'center', placeItems: 'center' }}>
              <Image
                sx={{
                  order: { base: 0, xl: 1 },
                  animation: `${fadeInLeft} 0.5s 1s`,
                  animationFillMode: 'backwards',
                }}
                width={453}
                src={chaloupkaDashboardImage}
                alt=""
                aria-hidden
                style={{ mixBlendMode: 'multiply' }}
              />
            </Box>
          </Grid>

          <ConceptsWidget />

          <AnniversaryWidget />

          <ProductionGraph />
        </Grid>
      </Container>
    </Section>
  )
}
